


































import { Component, Prop, Mixins } from "vue-property-decorator";

// types
import { ICountry } from "@/models/constants";
import CountriesStore from "@/mixins/constants/countriesStore";

// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export enum COUNTRY_LABEL {
  CODE_AND_NAME = "code-and-name",
  CODE = "code",
  NAME = "name"
}

export enum COUNTRY_VALUE {
  OBJECT = "object",
  CODE = "code",
  ID = "id"
}

@Component({
  components: {
    Treeselect
  }
})
export default class CountrySelect extends Mixins(CountriesStore) {
  // Props
  @Prop({ required: true })
  public value!: string | number | ICountry | number[] | string[] | ICountry[];

  @Prop({ default: () => [] })
  public countryOptions!: ICountry[];

  @Prop({ default: () => [] })
  public countryCodes!: string[];

  @Prop({ default: () => [] })
  public countryIds!: ICountry["id"][];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public showFlagInValue!: boolean;

  @Prop({ default: true })
  public showFlagInOptions!: boolean;

  @Prop({ default: true })
  public clearable!: boolean;

  @Prop({ default: false })
  public isMultiselect!: boolean;

  @Prop({ default: false })
  public expanded!: boolean;

  @Prop({ default: COUNTRY_LABEL.CODE_AND_NAME })
  public labelType!: COUNTRY_LABEL;

  @Prop({ default: COUNTRY_VALUE.ID })
  public valueType!: COUNTRY_VALUE;

  public get options() {
    if (!this.countriesLoaded) {
      return [];
    }
    let countries: ICountry[] = [];
    if (this.countryOptions.length) {
      countries = this.countryOptions;
    } else if (this.countryCodes.length) {
      countries = this.countries.filter(c =>
        this.countryCodes.includes(c.code)
      );
    } else if (this.countryIds.length) {
      countries = this.countries.filter(c => this.countryIds.includes(c.id));
    } else {
      countries = this.countries;
    }
    countries = this.$_.cloneDeep(countries);
    return countries.map(country => {
      return {
        label: this.getOptionLabel(country),
        ...country
      };
    });
  }

  public getValue(value) {
    if (this.valueType === COUNTRY_VALUE.OBJECT) return value;
    else return this.$_.get(value, this.valueType);
  }

  public handleInput(value: any | any[]) {
    const values = (this.isMultiselect ? value : [value]) as any[];

    const countries = values.map(countryVal => {
      return this.options.find(c => {
        return this.$_.isEqual(this.getValue(c), countryVal);
      }) as ICountry | undefined;
    });

    this.$emit(
      "input",
      this.isMultiselect
        ? countries?.map(i => this.getValue(i))
        : this.getValue(countries[0])
    );
  }

  public get valueFormatted() {
    if (this.$_.isNil(this.value) || !this.options.length) return null;

    const values = (this.isMultiselect ? this.value : [this.value]) as any[];

    const countries = values.map(countryVal => {
      return this.options.find(c =>
        this.$_.isEqual(this.getValue(c), countryVal)
      ) as ICountry | undefined;
    });

    return this.isMultiselect
      ? countries.map(i => this.getValue(i))
      : this.getValue(countries?.[0]);
  }

  public getOptionLabel(country: ICountry) {
    if (this.labelType === COUNTRY_LABEL.CODE_AND_NAME) {
      return `<span class="has-text-grey-light">${country.code}</span> - ${country.name}`;
    }
    if (this.labelType === COUNTRY_LABEL.CODE) {
      return country.code;
    }
    return country.name;
  }
}
